import ImageText from './imageText'

export default ImageText